<template>
  <div> 
    <div class="cardContainer" v-if="listType=='Card'">
      <club-card v-for="(club, index) in clubs" :key="index" :club="club"></club-card>
    </div>

    <div v-if="listType=='Table' && clubs.length > 0" class="flexrow">
      <img :src="clubIcon" alt="clubs" class="logo-display-small" />
      <div class="result-table">
        <div class="result-header" v-if="topX <= clubs.length">{{ $t('clubs.found') }} ({{ topX }} {{ $t('persons.outOf') }} {{ clubs.length }})</div>
        <div class="result-header" v-if="topX > clubs.length">{{ $t('clubs.found') }} ({{ clubs.length }})</div>
        <div class="result-header" v-if="topX == -1"><h2>clubs</h2></div>
        <div v-for="(club, index) in topClubs" :key="index" :club="club" class="result-line">
          <router-link :to="/clubs/ + club.clubId" class="link">{{club.name}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ClubCard from "@/components/clubs/ClubCard";

export default {
  name: 'ClubsList',
  components: {ClubCard},
  props: {
    clubs: Array,
    listType: String,
    topX: -1
  },
  data() {
    return {
      clubIcon: require('../../assets/img/CA_Club_black.png'),
    }
  },
  computed: {
    topClubs: function() {
      if (this.clubs.length > this.topX) {
        return this.clubs.slice(0, this.topX);
      } else 
        return this.clubs;
    }
  }
}
</script>

<style scoped>

.floatRight {
  float: right;
}

/* mobile */
@media screen and (max-width: 600px) {

}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .cardContainer {
    grid-template-columns: repeat(3, 1fr);
    width: 70vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .cardContainer {
    grid-template-columns: repeat(3, 1fr);
    width: 50vw;
  }
}

</style>

